module.exports = __webpack_public_path__ + "static/media/aw-rewards-fr.733312f8.png";